/**
 * How a product's discount is rendered in price UI. Shared across the
 * configurator, product-compare, and mattress-match apps plus the shared
 * price components, so it lives in models/ rather than any one app.
 */
export enum DiscountDisplayMode {
    DISABLED = "disabled",
    AUTOMATIC = "automatic",
    SHOW_PERCENTAGE = "show-percentage",
    SHOW_ABSOLUTE = "show-absolute",
}
